import {
  getPdtExpirationDate,
  getPdtFreshnessStatus,
  getPdtScanNotice,
  PdtFreshnessStatus,
  type PdtScanStatus,
} from '@access-cms/shared-constants';

import { ErrorIcon, WarningIcon } from '../../../../components/Icon';

import { formatDate } from '@/utils';

import './PdtFreshnessNotice.css';

interface PdtFreshnessNoticeProps {
  'data-testid'?: string;
  pdtScanStatus?: PdtScanStatus | string | null;
  pdtUploadedAt?: string | null;
}

export function PdtFreshnessNotice({
  'data-testid': dataTestId,
  pdtScanStatus,
  pdtUploadedAt,
}: PdtFreshnessNoticeProps) {
  const scanNotice = getPdtScanNotice(pdtScanStatus);

  if (scanNotice) {
    const Icon = scanNotice.variant === 'error' ? ErrorIcon : WarningIcon;

    return (
      <div
        className='pdt-freshness-notice'
        data-testid={dataTestId}
        role='status'>
        <Icon
          ariaLabel=''
          className='pdt-freshness-notice__icon'
          size={18}
        />
        <span className='pdt-freshness-notice__text'>{scanNotice.message}</span>
      </div>
    );
  }

  const freshness = getPdtFreshnessStatus(pdtUploadedAt);

  if (freshness === PdtFreshnessStatus.NEEDS_UPDATE) {
    const expirationDate = getPdtExpirationDate(pdtUploadedAt);

    return (
      <div
        className='pdt-freshness-notice'
        data-testid={dataTestId}
        role='status'>
        <WarningIcon
          ariaLabel=''
          className='pdt-freshness-notice__icon'
          size={18}
        />
        <span className='pdt-freshness-notice__text'>
          This PDT will expire on {expirationDate ? formatDate(expirationDate) : '-'}.
        </span>
      </div>
    );
  }

  if (freshness === PdtFreshnessStatus.EXPIRED) {
    return (
      <div
        className='pdt-freshness-notice'
        data-testid={dataTestId}
        role='status'>
        <ErrorIcon
          ariaLabel=''
          className='pdt-freshness-notice__icon'
          size={18}
        />
        <span className='pdt-freshness-notice__text'>This PDT is expired and needs to be updated.</span>
      </div>
    );
  }

  return null;
}
